import {Component, Inject, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LayoutAlertService} from 'src/app/admin/layout-alert.service';
import {AppFileInputComponent} from 'src/app/shared/inputs/app-file-input/app-file-input.component';
import {UploadMessagesService} from 'src/app/shared/services/upload-messages.service';

@Component({
    selector: 'app-image-upload-popup',
    templateUrl: './image-upload-popup.component.html',
    styleUrls: ['./image-upload-popup.component.scss'],
    standalone: false
})
export class ImageUploadPopupComponent implements OnInit {
  form: FormGroup;
  popupTitle = 'Upload image';
  immediateSend = false;
  setAnchors = false;

  @ViewChildren(AppFileInputComponent) flow: QueryList<AppFileInputComponent>;

  constructor(
    public dialogRef: MatDialogRef<ImageUploadPopupComponent>,
    private uploadMessagesService: UploadMessagesService,
    @Inject(MAT_DIALOG_DATA) public data: ImageUploadPopupData,
    private layoutAlertService: LayoutAlertService,
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      image_url: new FormControl(''),
      image_url_preview: new FormControl(''),
      anchor_x: new FormControl(0.5),
      anchor_y: new FormControl(1),
    });
    this.popupTitle = this.data.popupTitle ?? this.popupTitle;
    this.immediateSend = this.data.immediateSend ?? this.immediateSend;
    if (this.data.imageUrl) {
      this.form.get('image_url_preview').setValue(this.data.imageUrl);
    }
    if (this.data.imageUrl) {
      this.form.get('image_url').setValue(this.data.image);
    }
    if (this.data.anchor_x !== undefined) {
      this.setAnchors = true;
      this.form.get('anchor_x').setValue(this.data.anchor_x);
    }
    if (this.data.anchor_y !== undefined) {
      this.form.get('anchor_y').setValue(this.data.anchor_y);
    }
  }

  onFileSuccessfullyAddedImage(uploadedFileId, formControl: FormControl, formControlPreview: FormControl) {
    const errorMessages = this.uploadMessagesService.errorMessages;

    if (uploadedFileId in errorMessages) {
      formControl.setValue(null);
      formControlPreview.setValue(null);
      this.layoutAlertService.error(errorMessages[uploadedFileId]);
    } else {
      if (this.immediateSend) {
        formControl.setValue(uploadedFileId);
        this.submitForm();
      } else {
        formControl.setValue(uploadedFileId);
      }
    }
  }

  onFileAdded(event, formControl?: FormControl) {
    const file = event[0][0].file;
    if (formControl) {
      formControl.markAllAsTouched();
    }
    if (formControl && file && file.type.startsWith('image/')) {
      const reader = new FileReader();

      reader.onload = event => {
        formControl.setValue(event.target.result);
      };

      reader.readAsDataURL(file);
    }
    this.uploadFiles();
  }

  uploadFiles() {
    for (let component of this.flow) {
      component.uploadFlow();
    }
  }

  fileRemoved(event, formControl: FormControl, formControlPreview?: FormControl) {
    if (event) {
      formControl.setValue('');
      if (formControlPreview) {
        formControlPreview.setValue('');
      }
    }
  }

  changeToTouched(formControl: FormControl) {
    formControl.markAllAsTouched();
  }

  setAnchorPosition(position) {
    if (
      position &&
      position.anchorX !== undefined &&
      position.anchorX !== null &&
      position.anchorY !== undefined &&
      position.anchorY !== null
    ) {
      this.form.get('anchor_x').setValue(position.anchorX);
      this.form.get('anchor_y').setValue(position.anchorY);
    }
  }

  submitForm() {
    this.dialogRef.close({action: 'saved', data: this.form.getRawValue()});
  }

  clear() {
    this.dialogRef.close({action: 'clear'});
  }

  closeDialog() {
    this.dialogRef.close({action: 'closing'});
  }
}

export interface ImageUploadPopupData {
  imageUrl: string;
  image?: string;
  popupTitle: string;
  immediateSend: boolean;
  anchor_x?: number;
  anchor_y?: number;
}
